import { API, Auth, graphqlOperation } from "aws-amplify";
import {
    CognitoUserSession,
    CognitoIdToken,
    CognitoRefreshToken,
    CognitoAccessToken,
} from "amazon-cognito-identity-js";
import { getCognitoUserSessions,loginCognitoUser } from './graphql/';

/**
 * Injects an access token, id token, and refresh token into AWS Amplify for idenity and access
 * management. Cognito will store these tokens in memory and they will persist upon requesting
 * additional pages from the same domain.
 *
 * Calling this method should have the same effect as signing in with Auth.signIn(). When an
 * id or access token expires, Cognito will automatically retrieve new ones using the refresh
 * token passed.
 *
 * Note: Token injection is not "officially" supported by Amplify. The only forms of sign-in
 * Amplify supports are username & password or federated sign-in.
 *
 * @param accessToken The access token to be injected. Access tokens grant access to resources.
 * @param idToken The id token to be injected. Id tokens contain claims about identity.
 * @param refreshToken The refresh token to be injected. Refresh tokens can obtain new access
 * and id tokens for a long period of time (usually up to a year).
 */
export const injectTokensIntoAmplify = async(accessToken: string, idToken: string, refreshToken: string, callBack: any) => {
    const session = new CognitoUserSession({
        IdToken: new CognitoIdToken({
            IdToken: idToken,
        }),
        RefreshToken: new CognitoRefreshToken({
            RefreshToken: refreshToken,
        }),
        AccessToken: new CognitoAccessToken({
            AccessToken: accessToken,
        }),
    });
    Auth.Credentials.set(session, "session");

    

    // The function createCognitoUser is private in Amplify. So, we need to cast it
    // in order to call it.
    const currentUser = (Auth as any).createCognitoUser(session.getIdToken().decodePayload()["cognito:username"]);
    // This calls cacheTokens() in Cognito SDK. Assigns the tokens to the local identity.
    currentUser.setSignInUserSession(session)
   const devicekey = Date.now()?.toString();
 
    localStorage.setItem('deviceKey', devicekey);
    const createSession = (await API.graphql(
        graphqlOperation(loginCognitoUser, { LinkedSessionID: devicekey })
    )) as {
        data?: {
            loginCognitoUser?:
                | {
                      sessionid?: string;
                  }
                | Array<{
                      sessionid?: string;
                  }>;
        };
    };
    console.log({ createSession });
    const loginSessionData = createSession?.data?.loginCognitoUser;
    const sessionId = Array.isArray(loginSessionData)
        ? loginSessionData?.[0]?.sessionid
        : loginSessionData?.sessionid;
    if (sessionId) {
        localStorage.setItem('sessionID', sessionId);
    }
 
    const sessions = (await API.graphql(graphqlOperation(getCognitoUserSessions))) as any;
    console.log({sessions});
        callBack()
    console.log('done')
};
